module.exports = __webpack_public_path__ + "img/101.42939da6.png";